import { CALL_API } from "../api.middleware";
import {
  SHOW_PURCHASE_CONFIRMATION,
  SHOW_PURCHASE_CONFIRMATION_SUCCESS,
  SHOW_PURCHASE_CONFIRMATION_FAILED,
  CONFIRM_PURCHASE,
  CONFIRM_PURCHASE_SUCCESS,
  CONFIRM_PURCHASE_FAILED,
  SET_SIP_DETAILS,
  SIP_SAVE_DATA,
  SET_NEW_PAN,
  SIP_SAVE_DATA_SUCCESS,
  SIP_SAVE_DATA_FAILED,
  SET_SWITCH_DETAILS,
  SET_STP_DETAILS,
  GET_EARNINGS,
  GET_EARNINGS_SUCCESS,
  GET_EARNINGS_FAILED,
  SAVE_TRANSACTION_DETAILS,
} from "../types";

export const submitPurchaseData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SentpurchasemailRed",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const showPurchaseConfirmation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ShowpurchaseconfirmationData",
        params,
        method: "GET",
        types: [
          SHOW_PURCHASE_CONFIRMATION,
          SHOW_PURCHASE_CONFIRMATION_SUCCESS,
          SHOW_PURCHASE_CONFIRMATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const saveTransactionDetails = (body) => {
  return {
    type: SAVE_TRANSACTION_DETAILS,
    body,
  };
};
export const saveSipData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SIPSave",
        params,
        method: "GET",
        types: [SIP_SAVE_DATA, SIP_SAVE_DATA_SUCCESS, SIP_SAVE_DATA_FAILED],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const confirmPurchase = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveDTRWeb",
        params,
        method: "GET",
        types: [
          CONFIRM_PURCHASE,
          CONFIRM_PURCHASE_SUCCESS,
          CONFIRM_PURCHASE_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getAssetClasses = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetAssetclass",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCheckPanKotm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CheckPANKotm",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCheckPanAotm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CheckPANAotm",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getOtherSchemes = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getOtherSchemesSwitch",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getBankDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetRedemptionBankDeatils",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getRedemptionPaymentDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/exitloadcalc",
        params,
        method: "GET",
        types: [
          SHOW_PURCHASE_CONFIRMATION,
          SHOW_PURCHASE_CONFIRMATION_SUCCESS,
          SHOW_PURCHASE_CONFIRMATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const redemptionConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Savetransaction_red",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const swpOptions = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getMasterSIP",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const CalcSIPEnddt = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CalcSIPEnddt",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const swpConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SWPDetailsSave_WEB",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const stpConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveSTPconfirmationWeb",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const physicalTransaction = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "",
        body,
        method: "POST",
        isFile: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const setSipDetails = (data) => {
  return {
    type: SET_SIP_DETAILS,
    body: data,
  };
};

export const setNewPAN = (pan) => {
  return {
    type: SET_NEW_PAN,
    body: pan,
  };
};

export const setSwitchDetails = (data) => {
  return {
    type: SET_SWITCH_DETAILS,
    body: data,
  };
};

export const setStpDetails = (data) => {
  return {
    type: SET_STP_DETAILS,
    body: data,
  };
};

export const getFundWiseEarnings = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetBrokerageDetails`,
        isOld: true,
        params,
        method: "GET",
        types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
        showLoader: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getMinimumAmount = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/Ktrack_GetMinAmt`,
        params,
        method: "GET",
        // types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
        // showLoader: true
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getNctType = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetNCTKtrackgo`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getNctSave = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: ``,
        body,
        method: "POST",
        isNct: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getEnach = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/enachregdbilldesk`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const EBamountValidation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrack_mirae_EB_amt_validation",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    return error;
  }
};

export const getEnachFolios = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetEnachBankByFolio`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getEnachFequency = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetEnachFrequency`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getEnachFoliosList = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/CheckPANAotm`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    // alert(`${error}`);
    console.log(`${error}`);
  }
};

export const getEnachValidateBank = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/ktrack_enach_bank_valid`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
    // console.log(`${error}`)
  }
};
export const checkPAN = (payload) => async (dispatch) => {
  try {
    const requestBody = {
      Pan: payload.pan,
      PanName: payload.PanName,
      PanDOB: payload.PanDOB,
      JH1_PAN: payload.jointHolder1Pan,
      JH1_PanDOB: payload.jointHolder1PanDOB,
      JH1_PanName: payload.jointHolder1PanName,
      JH2_PAN: payload.jointHolder2Pan,
      JH2_PanDOB: payload.jointHolder2PanDOB,
      JH2_PanName: payload.jointHolder2PanName,
      G_Pan: payload.guardianPan,
      G_PanName: payload.guardianPanName,
      G_PanDOB: payload.guardianPanDOB,
      TrxnType: "New",
      Acno: 0,
      Branch: "WB99",
      Fund: payload.fund,
      invStatus: payload.invStatus,
      JH1_invStatus:payload.JH1_invStatus,
      JH2_invStatus:payload.JH2_invStatus,
    };

    const response = await dispatch({
      [CALL_API]: {
        url: "/Wrappermethod",
        method: "GET",
        showLoader: true,
        params: requestBody,
        skipEncode: true,
      },
    });
    const { DtData = [] } = response;
    const [panAadhaaarResponse = {}] = DtData;
    return panAadhaaarResponse;
  } catch (error) {
    alert(`${error}`);
  }
};
